/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const inventoryRoutes = {
  path: '/inventory',
  component: Layout,
  redirect: '/inventory/users',
  name: 'Inventory',
  alwaysShow: true,
  meta: {
    title: 'inventory',
    icon: 'Grid',
    permissions: [
      'category_view',
      'brand_view',
      'unit_view',
      'product_view',
      'warehouse_view',
      'warehouse_inventory_view',
      'project_inventory_view',
      'stock_view',
      'asset_view',
      'transfer_view',
      'wastage_view',
      'consumption_view',
      'quotation_price_view',
      'client_price_view',
      'subcontractor_price_view',
    ],
  },
  children: [
    /** inventory managements */
    {
      path: 'categories/list',
      component: () => import('../views/categories/List'),
      name: 'categoryList',
      meta: {
        title: 'categoryList',
        icon: 'Memo',
        permissions: ['category_view'],
      },
    },
    {
      path: 'categories/edit/:id(\\d+)',
      component: () => import('../views/categories/components/CategoryEdit'),
      name: 'EditCategory',
      meta: {
        title: 'EditCategory',
        noCache: true,
        permissions: ['category_edit'],
      },
      hidden: true,
    },
    // brand routes
    {
      path: 'brands/list',
      component: () => import('../views/brand/List'),
      name: 'brandList',
      meta: { title: 'brandList', icon: 'Memo', permissions: ['brand_view'] },
    },
    {
      path: 'brands/edit/:id(\\d+)',
      component: () => import('../views/brand/components/BrandEdit'),
      name: 'EditBrand',
      meta: { title: 'EditBrand', noCache: true, permissions: ['brand_edit'] },
      hidden: true,
    },
    // unit routes
    {
      path: 'units/list',
      component: () => import('../views/unit/List'),
      name: 'unitList',
      meta: { title: 'unitList', icon: 'Memo', permissions: ['unit_view'] },
    },
    {
      path: 'units/edit/:id(\\d+)',
      component: () => import('../views/unit/components/UnitEdit'),
      name: 'EditUnit',
      meta: { title: 'EditUnit', noCache: true, permissions: ['unit_edit'] },
      hidden: true,
    },

    // product routes
    {
      path: 'product/list',
      component: () => import('../views/product/List'),
      name: 'ProductList',
      meta: {
        title: 'productList',
        icon: 'Memo',
        permissions: ['product_view'],
      },
    },
    {
      path: 'products/edit/:id(\\d+)',
      component: () => import('../views/product/components/ProductEdit'),
      name: 'ProductEdit',
      meta: {
        title: 'ProductEdit',
        noCache: true,
        permissions: ['product_edit'],
      },
      hidden: true,
    },
    // product-estimate routes
    {
      path: 'product-estimate/edit/:id',
      component: () => import('../views/product-estimate/View'),
      name: 'ProductEstimateEdit',
      meta: {
        title: 'ProductEstimateEdit',
        noCache: true,
        permissions: ['product_view'],
      },
      hidden: true,
    },
    // production routes
    {
      path: 'production/create/:id',
      component: () => import('../views/production/Create'),
      name: 'ProductionCreate',
      meta: {
        title: 'ProductionCreate',
        noCache: true,
        permissions: ['product_add'],
      },
      hidden: true,
    },
    {
      path: 'production/view/:id',
      component: () => import('../views/production/View'),
      name: 'ProductionView',
      meta: {
        title: 'ProductionEdit',
        noCache: true,
        permissions: ['product_view'],
      },
      hidden: true,
    },
    // warehouse routes
    {
      path: 'warehouses/list',
      component: () => import('../views/warehouse/List'),
      name: 'warehouseList',
      meta: {
        title: 'warehouseList',
        icon: 'Memo',
        permissions: ['warehouse_view'],
      },
    },
    {
      path: 'warehouses/edit/:id(\\d+)',
      component: () => import('../views/warehouse/components/WarehouseEdit'),
      name: 'EditWarehouse',
      meta: {
        title: 'EditWarehouse',
        noCache: true,
        permissions: ['warehouse_edit'],
      },
      hidden: true,
    },
    // warehouse inventory routes
    {
      path: 'warehouse-inventory/list',
      component: () => import('../views/warehouse-inventory/List'),
      name: 'warehouseInventoryList',
      meta: {
        title: 'warehouseInventoryList',
        icon: 'Memo',
        permissions: ['warehouse_inventory_view'],
      },
    },
    {
      path: 'warehouse-inventory/pending-list',
      component: () => import('../views/warehouse-inventory/PendingList'),
      name: 'warehouseInventoryPendingList',
      meta: {
        title: 'warehouseInventoryPendingList',
        icon: 'Memo',
        permissions: ['warehouse_inventory_receive'],
      },
      hidden: true,
    },
    {
      path: 'receive-product/:id(\\d+)',
      component: () => import('../views/warehouse-inventory/ReceiveProduct'),
      name: 'warehouseInventoryReceiveProduct',
      meta: {
        title: 'warehouseInventoryReceiveProduct',
        icon: 'Memo',
        permissions: ['warehouse_inventory_receive'],
      },
      hidden: true,
    },
    // project inventory routes
    {
      path: 'project-inventory/list',
      component: () => import('../views/project-inventory/List'),
      name: 'projectInventoryList',
      meta: {
        title: 'projectInventoryList',
        icon: 'Memo',
        permissions: ['project_inventory_view'],
      },
    },
    {
      path: 'project-inventory/pending-list',
      component: () => import('../views/project-inventory/PendingList'),
      name: 'projectInventoryPendingList',
      meta: {
        title: 'projectInventoryPendingList',
        icon: 'Memo',
        permissions: ['project_inventory_receive'],
      },
      hidden: true,
    },
    {
      path: 'project-inventory/receive-product/:id(\\d+)',
      component: () => import('../views/project-inventory/ReceiveProduct'),
      name: 'projectInventoryReceiveProduct',
      meta: {
        title: 'projectInventoryReceiveProduct',
        icon: 'Memo',
        permissions: ['project_inventory_receive'],
      },
      hidden: true,
    },

    // stock routes
    {
      path: 'stock/list',
      component: () => import('../views/stock/List'),
      name: 'stockList',
      meta: { title: 'stockList', icon: 'Memo', permissions: ['stock_view'] },
    },

    // Asset routes
    {
      path: 'asset/list',
      component: () => import('../views/asset/List'),
      name: 'assetList',
      meta: { title: 'assetList', icon: 'Memo', permissions: ['asset_view'] },
    },
    {
      path: 'asset/create',
      component: () => import('../views/asset/Create'),
      name: 'assetCreate',
      meta: { title: 'assetCreate', icon: 'Memo', permissions: ['asset_add'] },
      hidden: true,
    },
    {
      path: 'asset/edit/:id',
      component: () => import('../views/asset/Edit'),
      name: 'assetEdit',
      meta: { title: 'assetEdit', noCache: true, permissions: ['asset_edit'] },
      hidden: true,
    },
    {
      path: 'asset/view/:id',
      component: () => import('../views/asset/View'),
      name: 'assetView',
      meta: { title: 'assetView', icon: 'Memo', permissions: ['asset_view'] },
      hidden: true,
    },
    {
      path: 'asset/report',
      component: () => import('../views/asset/Report'),
      name: 'assetReport',
      meta: { title: 'assetReport', icon: 'Memo', permissions: ['asset_view'] },
      hidden: true,
    },
    {
      path: 'transfer/report',
      component: () => import('../views/transfer/Report'),
      name: 'transferReport',
      meta: { title: 'transferReport', icon: 'Memo', permissions: ['transfer_view'] },
      hidden: true,
    },
    // Transfer routes
    {
      path: 'transfer/list',
      component: () => import('../views/transfer/List'),
      name: 'transferList',
      meta: {
        title: 'transferList',
        icon: 'Memo',
        permissions: ['transfer_view'],
      },
    },
    {
      path: 'transfers/Create',
      component: () => import('../views/transfer/Create'),
      name: 'transferCreate',
      meta: {
        title: 'transferCreate',
        icon: 'Memo',
        permissions: ['transfer_add'],
      },
      hidden: true,
    },
    {
      path: 'transfers/view/:id(\\d+)',
      component: () => import('../views/transfer/View'),
      name: 'transferView',
      meta: {
        title: 'transferView',
        icon: 'Memo',
        permissions: ['transfer_view'],
      },
      hidden: true,
    },
    {
      path: 'transfers/edit/:id',
      component: () => import('../views/transfer/Edit'),
      name: 'transferEdit',
      meta: {
        title: 'transferEdit',
        icon: 'Memo',
        permissions: ['transfer_edit'],
      },
      hidden: true,
    },

    // Delivery routes
    {
      path: 'delivery/list',
      component: () => import('../views/delivery/List'),
      name: 'deliveryList',
      meta: {
        title: 'deliveryList',
        icon: 'Memo',
        permissions: ['delivery_view'],
      },
    },
    {
      path: 'deliveries/Create',
      component: () => import('../views/delivery/Create'),
      name: 'deliveryCreate',
      meta: {
        title: 'deliveryCreate',
        icon: 'Memo',
        permissions: ['delivery_add'],
      },
      hidden: true,
    },
    {
      path: 'deliveries/view/:id',
      component: () => import('../views/delivery/View'),
      name: 'deliveryView',
      meta: {
        title: 'deliveryView',
        icon: 'Memo',
        permissions: ['delivery_edit'],
      },
      hidden: true,
    },

    {
      path: 'wastage/report',
      component: () => import('../views/wastage/Report'),
      name: 'wastageReport',
      meta: { title: 'wastageReport', icon: 'Memo', permissions: ['wastage_view'] },
      hidden: true,
    },
    // Wastage routes
    {
      path: 'wastage/list',
      component: () => import('../views/wastage/List'),
      name: 'wastageList',
      meta: {
        title: 'wastageList',
        icon: 'Memo',
        permissions: ['wastage_view'],
      },
    },
    {
      path: 'wastages/Create',
      component: () => import('../views/wastage/Create'),
      name: 'wastageCreate',
      meta: {
        title: 'wastageCreate',
        icon: 'Memo',
        permissions: ['wastage_add'],
      },
      hidden: true,
    },
    {
      path: 'wastages/view/:id(\\d+)',
      component: () => import('../views/wastage/View'),
      name: 'wastageView',
      meta: {
        title: 'wastageView',
        icon: 'Memo',
        permissions: ['wastage_view'],
      },
      hidden: true,
    },
    {
      path: 'wastages/check/:id',
      component: () => import('../views/wastage/Edit'),
      name: 'wastageCheck',
      meta: {
        title: 'wastageCheck',
        icon: 'Memo',
        permissions: ['wastage_check'],
      },
      hidden: true,
    },
    {
      path: 'wastages/approve/:id',
      component: () => import('../views/wastage/Edit'),
      name: 'wastageApprove',
      meta: {
        title: 'wastageApprove',
        icon: 'Memo',
        permissions: ['wastage_approve'],
      },
      hidden: true,
    },

    // Consumption routes
    {
      path: 'consumption/list',
      component: () => import('../views/consumption/List'),
      name: 'consumptionList',
      meta: {
        title: 'consumptionList',
        icon: 'Memo',
        permissions: ['consumption_view'],
      },
    },
    {
      path: 'consumptions/Create',
      component: () => import('../views/consumption/Create'),
      name: 'consumptionCreate',
      meta: {
        title: 'consumptionCreate',
        icon: 'Memo',
        permissions: ['consumption_add'],
      },
      hidden: true,
    },
    {
      path: 'consumptions/view/:id(\\d+)',
      component: () => import('../views/consumption/View'),
      name: 'consumptionView',
      meta: {
        title: 'consumptionView',
        icon: 'Memo',
        permissions: ['consumption_view'],
      },
      hidden: true,
    },
    {
      path: 'consumptions/check/:id',
      component: () => import('../views/consumption/Edit'),
      name: 'consumptionCheck',
      meta: {
        title: 'consumptionCheck',
        icon: 'Memo',
        permissions: ['consumption_check'],
      },
      hidden: true,
    },
    {
      path: 'consumptions/approve/:id',
      component: () => import('../views/consumption/Edit'),
      name: 'consumptionApprove',
      meta: {
        title: 'consumptionApprove',
        icon: 'Memo',
        permissions: ['consumption_approve'],
      },
      hidden: true,
    },

    // Quotation routes
    {
      path: 'quotation/list',
      component: () => import('../views/quotation/List'),
      name: 'quotationList',
      meta: {
        title: 'quotationList',
        icon: 'Memo',
        permissions: ['quotation_price_view'],
      },
    },
    {
      path: 'quotation/create',
      component: () => import('../views/quotation/Create'),
      name: 'quotationEdit',
      meta: {
        title: 'quotationEdit',
        icon: 'Memo',
        permissions: ['quotation_price_add'],
      },
      hidden: true,
    },
    {
      path: 'quotation/view/:id(\\d+)',
      component: () => import('../views/quotation/View'),
      name: 'quotationView',
      meta: {
        title: 'quotationEdit',
        noCache: true,
        permissions: ['quotation_price_edit'],
      },
      hidden: true,
    },
    // client-price-list routes
    {
      path: 'client-price-list/list',
      component: () => import('../views/client-price-list/List'),
      name: 'clientPriceList',
      meta: {
        title: 'clientPriceList',
        icon: 'Memo',
        permissions: ['client_price_view'],
      },
    },
    {
      path: 'client-price-list/create',
      component: () => import('../views/client-price-list/Create'),
      name: 'clientPriceCreate',
      meta: {
        title: 'clientPriceCreate',
        icon: 'edit',
        permissions: ['client_price_add'],
      },
      hidden: true,
    },
    {
      path: 'client-price-list/view/:id(\\d+)',
      component: () => import('../views/client-price-list/View'),
      name: 'clientPriceEdit',
      meta: {
        title: 'clientPriceEdit',
        noCache: true,
        permissions: ['client_price_edit'],
      },
      hidden: true,
    },

    // subcontractor-price-list routes
    {
      path: 'subcontractor-price-list/list',
      component: () => import('../views/subcontractor-price-list/List'),
      name: 'subcontractorPriceList',
      meta: {
        title: 'subcontractorPriceList',
        icon: 'Memo',
        permissions: ['subcontractor_price_view'],
      },
    },
    {
      path: 'subcontractor-price-list/create',
      component: () => import('../views/subcontractor-price-list/Create'),
      name: 'subcontractorPriceCreate',
      meta: {
        title: 'subcontractorPriceCreate',
        icon: 'edit',
        permissions: ['subcontractor_price_add'],
      },
      hidden: true,
    },

    {
      path: 'subcontractor-price-list/view/:id(\\d+)',
      component: () => import('../views/subcontractor-price-list/View'),
      name: 'subcontractorPriceEdit',
      meta: {
        title: 'subcontractorPriceEdit',
        noCache: true,
        permissions: ['subcontractor_price_edit'],
      },
      hidden: true,
    },

    {
      path: 'reports',
      component: () => import('../views/report/Index'),
      name: 'inventoryReport',
      meta: {
        title: 'Reports',
        icon: 'Memo',
        permissions: ['inventory_report_view'],
      },
    },

    {
      path: 'reports/summary',
      component: () => import('../views/report/Summary'),
      name: 'summaryReport',
      meta: {
        title: 'Summery Reports',
        icon: 'report',
        permissions: ['inventory_report_view'],
      },
      hidden: true,
    },

    {
      path: 'warehouse-inventory/mrr-report',
      component: () => import('../views/warehouse-inventory/mrrReport.vue'),
      name: 'warehouseInventoryMrrReport',
      meta: {
        title: 'Warehouse Inventory Mrr Report',
        icon: 'Memo',
        permissions: ['inventory_report_view'],
      },
      hidden: true,
    },
    {
      path: 'warehouse-inventory/mrr-format/:id',
      component: () => import('../views/warehouse-inventory/mrrFormat.vue'),
      name: 'warehouseInventoryMrrFormat',
      meta: {
        title: 'Warehouse MRR Format',
        icon: 'Memo',
        permissions: ['inventory_report_view'],
      },
      hidden: true,
    },
    {
      path: 'project-inventory/mrr-report',
      component: () => import('../views/project-inventory/mrrReport.vue'),
      name: 'projectInventoryMrrReport',
      meta: {
        title: 'Project Inventory Mrr Report',
        icon: 'Memo',
        permissions: ['inventory_report_view'],
      },
      hidden: true,
    },
    {
      path: 'project-inventory/mrr-format/:id',
      component: () => import('../views/project-inventory/mrrFormat.vue'),
      name: 'projectInventoryMrrFormat',
      meta: {
        title: 'Project MRR Format',
        icon: 'Memo',
        permissions: ['inventory_report_view'],
      },
      hidden: true,
    },
  ],
};

export default inventoryRoutes;
